import { StateOperator } from '@ngxs/store';
import { insertItem } from '@ngxs/store/operators';

import { composeWithDeepEqual } from './composeWithDeepEqual';
import { uniqArray } from './uniqArray';

export function insertItemWithUniq<T>(item: T): StateOperator<any[]> {
  return composeWithDeepEqual(insertItem(item), uniqArray());
}
